'use client'

import { useEffect, useState } from 'react'
import { useAuth } from '@/contexts/auth-context'
import { LoginModal } from '@/components/auth/login-modal'

interface RequireAuthProps {
  children: React.ReactNode
  fallback?: React.ReactNode
}

export function RequireAuth({ children, fallback }: RequireAuthProps) {
  const { isAuthenticated, isLoading } = useAuth()
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false)

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      setIsLoginModalOpen(true)
    }
  }, [isLoading, isAuthenticated])

  if (isLoading) {
    return fallback || <div className="p-4 text-center">Loading...</div>
  }

  return (
    <>
      {isAuthenticated ? children : fallback || null}
      <LoginModal isOpen={isLoginModalOpen} onClose={() => setIsLoginModalOpen(false)} />
    </>
  )
} 